export default "__VITE_ASSET__98dd487c__"